import { Dumbbell, Users, Music, Gift, Sparkles } from "lucide-react";

const WAYS = [
  { key: "warm_up", icon: Dumbbell, title: "Lead the Warm-Up", desc: "Own the mic and get 200+ runners moving before the horn." },
  { key: "gym_team", icon: Users, title: "Bring a Gym Team", desc: "Rally members, form a team, brand your finish-line photo." },
  { key: "cheer_zone", icon: Music, title: "Sponsor a Cheer Zone", desc: "Set up on-course to hype runners at mile markers." },
  { key: "raffle", icon: Gift, title: "Donate a Raffle Item", desc: "Class packs, memberships, gear — win new customers." },
  { key: "wellness_table", icon: Sparkles, title: "Host a Wellness Table", desc: "Sample sessions, giveaways, stretch demos, health tips." },
];

export default function WellnessPartners({ onSponsor }) {
  return (
    <section
      id="wellness"
      data-testid="section-wellness"
      className="relative bg-[#0A0A0A] py-24 md:py-32 border-t border-[#27272A]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5">
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#EC008C] font-bold mb-4">
              Wellness Partners
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-tight text-white">
              Gyms, trainers &amp; <span className="text-[#00A651]">wellness brands</span>.
            </h2>
            <p className="mt-5 text-lg text-[#A3A3A3]">
              Wellness Partners include local <strong className="text-white">gyms</strong>, personal trainers,{" "}
              <strong className="text-white">fitness studios</strong>, yoga studios, pilates studios, boot camps,
              fitness instructors, wellness brands, health coaches, chiropractors, and health partners.
              This event is your stage. Show up for the community, grow your following, and put your brand in front of
              hundreds of active families.
            </p>
            <button
              onClick={() => onSponsor("general")}
              data-testid="wellness-partner-btn"
              className="mt-8 bg-[#EC008C] hover:bg-[#FF1FA8] text-white font-bold uppercase tracking-widest text-sm px-8 py-4 transition-all hover:-translate-y-0.5"
            >
              Become a wellness partner →
            </button>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
            {WAYS.map(({ key, icon: Icon, title, desc }, i) => (
              <button
                type="button"
                key={key}
                onClick={() => onSponsor(key)}
                data-testid={`wellness-card-${key}`}
                className={`text-left bg-[#141414] border border-[#27272A] p-6 hover:border-[#00A651]/60 hover:-translate-y-0.5 transition-all cursor-pointer ${
                  i === 4 ? "sm:col-span-2" : ""
                }`}
              >
                <Icon className={`w-7 h-7 mb-3 ${i % 2 === 0 ? "text-[#00A651]" : "text-[#EC008C]"}`} />
                <div className="font-display font-bold uppercase text-white text-lg">{title}</div>
                <div className="text-sm text-[#A3A3A3] mt-1.5">{desc}</div>
                <div className="mt-3 text-[10px] uppercase tracking-widest text-[#00A651] font-bold">Sign up →</div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
